import clsx from 'clsx'
import PropTypes from 'prop-types'
import * as am4core from '@amcharts/amcharts4/core'
import { Grid, Paper, Typography, Chip } from '@mui/material'

import { formatDateFromHyphenToSlash } from '../../../libs/date'
import { ReactComponent as Calendar } from '../../../assets/icons/calendar-blank.svg'
import { SHIPPING_STATUS_CODES } from '../../../common/constants'
import useTranslations from '../../../i18n/useTranslations'
import Chart from '../../../ui/components/chart'
import Loader from '../../../ui/views/Loader'

import useStyles from '../styles'

const COLOR_BY_STATUS_CODE_MAP = {
  [SHIPPING_STATUS_CODES.manifested]: am4core.color('#DF0024'),
  [SHIPPING_STATUS_CODES.collected]: am4core.color('#FFEB00'),
  [SHIPPING_STATUS_CODES.inTransit]: am4core.color('#00BEB4'),
  [SHIPPING_STATUS_CODES.delivering]: am4core.color('#821E82'),
  [SHIPPING_STATUS_CODES.delivered]: am4core.color('#B4D246'),
  [SHIPPING_STATUS_CODES.onHold]: am4core.color('#E6D2E6'),
  [SHIPPING_STATUS_CODES.pudo]: am4core.color('#C594C5'),
  [SHIPPING_STATUS_CODES.returned]: am4core.color('#FF5733'),
}

const StatisticsCard = ({
  period,
  chartData = [],
  isLoadingShippingsStatics = true,
}) => {
  const classes = useStyles()
  const t = useTranslations()

  const chartDataWithColor = chartData.map(datum => ({
    ...datum,
    color: COLOR_BY_STATUS_CODE_MAP[datum.code],
  }))

  const periodLabel = `${formatDateFromHyphenToSlash(
    period.startDate,
  )} - ${formatDateFromHyphenToSlash(period.endDate)}`

  return (
    <Grid item xs={12} md={6}>
      <Paper className={classes.paper}>
        <div className={classes.papeTitleWrapper}>
          <Typography
            variant="h2"
            className={clsx('secondaryTitle', 'decorator')}
          >
            {t('home:shipment-status')}
          </Typography>
          <Chip
            label={periodLabel}
            avatar={<Calendar />}
            className={classes.chip}
          />
        </div>
        <Typography className={classes.subtitle}>
          {t('home:your-activity')}
        </Typography>
        {isLoadingShippingsStatics ? (
          <Loader />
        ) : (
          <Chart id="chart" data={chartDataWithColor} />
        )}
      </Paper>
    </Grid>
  )
}

StatisticsCard.propTypes = {
  period: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
  }),
  chartData: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.number,
      percentage: PropTypes.number,
    }),
  ),
  isLoadingShippingsStatics: PropTypes.bool,
}

export default StatisticsCard
